import { BaseService, Service } from "/@/cool";
@Service("dealerShop")
class dealerShop extends BaseService {
	constructor() {
		super();

		let prefix = "";
		if (this.namespace) {
			prefix = this.namespace.replace(/\//g, ":") + ":";
		}

		this.permission["add"] = prefix + "add";
		this.permission["update"] = prefix + "update";
		this.permission["info"] = prefix + "info";
		this.permission["list"] = prefix + "list";
		this.permission["page"] = prefix + "page";
		this.permission["delete"] = prefix + "delete";
		this.permission["setting"] = prefix + "setting";
		this.permission["settingInfo"] = prefix + "settingInfo";
		this.permission["userInfo"] = prefix + "userInfo";
	}

	setting(params: any) {
		return this.request({
			url: "/setting",
			method: "POST",
			data: { ...params }
		});
	}
	settingInfo(params: any) {
		return this.request({
			url: "/settingInfo",
			method: "POST",
			data: { ...params }
		});
	}
	userInfo(params: any) {
		return this.request({
			url: "/userInfo",
			method: "POST",
			data: { ...params }
		});
	}
}
export default dealerShop;
